import { getLimitWhereInUse } from 'gql/query'

export const generateAiQuestions = async (questionInfo: any, workReqeustDetails: any, instruction: string, reference: string, user: any) => {
  try {
    const limitData: any = await getLimitWhereInUse()
    const limit = limitData?.ai_limit[0].limit ?? 10
    const acceptedQuestionType = ['MCQ', 'Fill']
    const subjectId = workReqeustDetails?.subject_id ?? ''
    //If user select bloom,difficulty levels, grades, question type and topic when creating workrequest,
    //Then question creator can't select items on creating phase
    //So this items will not present in form for that we also have to check the details on work request details
    const bloomLevelId = questionInfo?.bloom_level_id
      ? questionInfo.bloom_level_id
      : workReqeustDetails?.bloom_level_id
      ? workReqeustDetails.bloom_level_id
      : ''
    const difficultyId = questionInfo?.difficulty_level_id
      ? questionInfo.difficulty_level_id
      : workReqeustDetails?.difficulty_level_id
      ? workReqeustDetails.difficulty_level_id
      : ''
    const gradeIds =
      questionInfo?.grade_ids?.length > 0 ? questionInfo?.grade_ids : workReqeustDetails?.grade_ids?.length > 0 ? workReqeustDetails.grade_ids : []
    const questionTypeId = questionInfo?.question_type_id
      ? questionInfo.question_type_id
      : workReqeustDetails?.question_type_id
      ? workReqeustDetails.question_type_id
      : ''
    const topicId = questionInfo.topic_id ? questionInfo.topic_id : workReqeustDetails.topic_id ? workReqeustDetails.topic_id : ''

    //checking necessary details are presented or not
    if (bloomLevelId && difficultyId && gradeIds?.length > 0 && questionTypeId && topicId && subjectId) {
      //if question_type id is valid
      if (acceptedQuestionType.includes(questionTypeId)) {
        const latestQuestionSessionId = localStorage.getItem('ai_q_session') ? localStorage.getItem('ai_q_session') : ''
        // For development
        // const response = await fetch(
          // `http://localhost:3001/aiquestion/${user.id}`,
          // For production
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/aiquestion/${user.id}`,
          {
            method: 'POST',
            body: JSON.stringify({
              question_type: questionTypeId,
              grade_ids: gradeIds,
              subject_id: subjectId,
              blooms_level_Id: bloomLevelId,
              difficulty_id: difficultyId,
              topic_id: topicId,
              instructions: instruction,
              reference_text: reference,
              ai_session_id: latestQuestionSessionId,
              limit,
            }),
            headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
          }
        )
        const responseDetails = await response.json()
        console.log(responseDetails, 'response details')
        if (responseDetails.status) {
          //if questin type is MCQ

          if (responseDetails.sessionId) {
            localStorage.setItem('ai_q_session', responseDetails.sessionId)
          }
          if (questionTypeId === 'MCQ') {
            const question = responseDetails.question
            const title = question?.question_title ?? ''
            const question_insights = question?.question_title_insights ?? ''
            const option_details: any = []
            if (question?.question_options.length > 0) {
              question?.question_options.forEach((option: any) => {
                option_details.push({
                  option_flag: option.option_flag ?? '',
                  option_text: option.option ?? '',
                  option_insight: option.option_insight ?? '',
                })
              })
            }
            if (option_details.length > 0) {
              const newOptionDetails = { question_title: title, question_insights, option_details }
              return { newOptionDetails }
            } else {
              return { error: true, message: 'Failed to generated the question please try again later...' }
            }
            //if the question type is Fill
          } else if (questionTypeId === 'Fill') {
            const question = responseDetails.question
            const title = question?.question_title ?? ''
            const question_insights = question?.question_title_insights ?? ''
            const option_details: any = []
            if (question?.question_options.length > 0) {
              question?.question_options.forEach((option: any) => {
                option_details.push({ right_answer: option.right_answer ?? '', option_insights: option.option_insights ?? '' })
              })
            }
            if (option_details.length > 0) {
              const newOptionDetails = { question_title: title, question_insights, option_details }
              return { newOptionDetails }
            }
            return { error: true, message: 'Failed to generated the question please try again later...' }
          } else {
            return { error: true, message: "Can't proceed with this question type...." }
          }
        } else {
          //if error happend showing error which get from server
          return { error: true, message: responseDetails.message ?? 'unable to generate question please try again later!' }
        }
      } else {
        return { error: true, message: "Can't accept the question type" }
      }
    } else {
      return { error: true, message: 'Please fill the mandatory fields (Topic is also mandatory field for AMS-GPT)' }
    }
  } catch (err) {
    console.log(err, 'error')
    return { error: true, message: 'Server down please try again later...' }
  }

  //   return option_details
}